import { render } from "./SliderView.vue?vue&type=template&id=526d27e6"
import script from "./SliderView.vue?vue&type=script&lang=js"
export * from "./SliderView.vue?vue&type=script&lang=js"

import "./SliderView.vue?vue&type=style&index=0&id=526d27e6&lang=css"

import exportComponent from "/opt/builds/JFRxnycJ/0/firma/firmenwebseite/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__